module.exports = __webpack_public_path__ + "img/FullPage.cb3f52c6.png";